import Api from './Api'
import { errorHandler } from '../../utils'
import {
  AccountUserPaymentInterface,
  AddManualTransactionUserInterface
} from 'interfaces/AccountingInterface'
import axios from 'axios'
import { DataTableColumns } from 'interfaces'

class AccountingUser extends Api {
  readonly urls = {
    payment: '/AccountingUser/Payment',
    all: '/AccountingUser/AllAccountingUser',
    addManual:'/AccountingUser/Add',
  }

  payment = async (data: AccountUserPaymentInterface): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.payment, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
  all = async (): Promise<any> => {
    try {
      const result = await this.postJsonData(`${this.urls.all}`)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
  addManual = async (data: AddManualTransactionUserInterface): Promise<any> => {
    try {
      const url =
        this.urls.addManual +
        `?userID=${data.userID}&amount=${data.amount}
        &tarikh=${data.tarikh}&description=${data.description}`
      const result = await this.postData(url)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
}

export default AccountingUser
